import { __ } from 'wp.i18n';

export default [
  {
    id: 'apple-maps-esque',
    label: __('Apple Maps-esque'),
    style: require('./appleMapsEsque').default,
  },
  {
    id: 'assassins-creed',
    label: __("Assassin's Creed IV"),
    style: require('./assassinsCreed').default,
  },
  {
    id: 'blue-water',
    label: __('Blue Water'),
    style: require('./blueWater').default,
  },
  {
    id: 'captor',
    label: __('Captor'),
    style: require('./captor').default,
  },
  {
    id: 'dark',
    label: __('Dark'),
    style: require('./dark').default,
  },
  {
    id: 'dark-yellow',
    label: __('Dark Yellow'),
    style: require('./darkYellow').default,
  },
  {
    id: 'event-lighter',
    label: __('Event Lighter'),
    style: require('./evenLighter').default,
  },
  {
    id: 'flat-pale',
    label: __('Flat Pale'),
    style: require('./flatPale').default,
  },
  {
    id: 'future-blue',
    label: __('Future Blue'),
    style: require('./futureBlue').default,
  },
  {
    id: 'greyscale',
    label: __('Greyscale'),
    style: require('./greyscale').default,
  },
  {
    id: 'hot-pink',
    label: __('Hot Pink'),
    style: require('./hotPink').default,
  },
  {
    id: 'icy-blue',
    label: __('Icy Blue'),
    style: require('./icyBlue').default,
  },
  {
    id: 'light-and-dark',
    label: __('Light and Dark'),
    style: require('./lightAndDark').default,
  },
  {
    id: 'lost-in-the-desert',
    label: __('Lost in the Desert'),
    style: require('./lostInTheDesert').default,
  },
  {
    id: 'midnight-commander',
    label: __('Midnight Commander'),
    style: require('./midnightCommander').default,
  },
  {
    id: 'multi-brand-network',
    label: __('Multibrand Network'),
    style: require('./multiBrandNetwork').default,
  },
  {
    id: 'neutral-blue',
    label: __('Neutral Blue'),
    style: require('./neutralBlue').default,
  },
  {
    id: 'paper',
    label: __('Paper'),
    style: require('./paper').default,
  },
  {
    id: 'pastel-tones',
    label: __('Pastel Tones'),
    style: require('./pastelTones').default,
  },
  {
    id: 'red-hues',
    label: __('Red Hues'),
    style: require('./redHues').default,
  },
  {
    id: 'subtle-greyscale-map',
    label: __('Subtle Greyscale Map'),
    style: require('./subtleGreyscaleMap').default,
  },
  {
    id: 'the-propia-effect',
    label: __('The Propia Effect'),
    style: require('./thePropiaEffect').default,
  },
  {
    id: 'yellow-grey',
    label: __('Yellow Grey'),
    style: require('./yellowGrey').default,
  },
];
